import React from 'react';
import Skills from '../components/skills';
import { 
  IoLogoLinkedin,
  IoLogoGithub,
  IoLogoInstagram,
  IoMdCall,
} from 'react-icons/io';
import bg from '../assets/bg.png';
import { DiDatabase,DiResponsive } from "react-icons/di";

import {FaPaintbrush,FaLaptopCode,FaServer,FaFigma } from "react-icons/fa6";
import ReachMe from '../components/reach-me';
import { Slide,Zoom,Reveal } from 'react-reveal'; 
const About = () => {
  return (
    <section className='sm:min-w-full'>
        <div className='all bg-black text-white w-full'>
      <h1 className='text-3xl font-bold text-orange-default pt-10 pb-10 flex justify-center'>ABOUT ME</h1>

<div className="me flex flex-col md:flex-row justify-center items-center gap-y-10 md:gap-x-10 lg:pr-32">
  <Reveal>
        <div className="bg-black">
          <img src={bg} alt="" className=" w-8/12 lg:w-11/12 h-25 pb-10 ml-20 md:ml-64" />
        </div>
        </Reveal>
        <Zoom right>
        <div className="about w-12/12 md:w-12/12 lg:w-12/12  pl-12 md:pl-32 lg:ml-20 lg:mt-4">
          <h3 className="text-white font-bold text-xl lg:text-start">Hello, I'm <span className="text-orange-default">Leslie</span></h3>
          <p className="text-white font-medium mt-4 lg:w-9/12 w-11/12">
            I am a passionate web developer and designer with expertise in creating visually appealing and user-friendly websites. With a keen eye for detail and a strong understanding of user experience, I strive to deliver seamless and engaging online experiences.
          </p>
          <div className="more pb-12 grid grid-cols-1 sm:grid-cols-2 gap-y-6 lg:gap-y-10 md:pt-5">
            <div className="container">
              <p className="text-orange-default font-bold text-xl">Names</p>
              <p className="text-white font-medium">UHIRIWE Anne Leslie</p>
            </div>
            <div className="container">
              <p className="text-orange-default font-bold text-xl">Country</p>
              <p className="text-white font-medium">Rwanda</p>
            </div>
            <div className="container">
              <p className="text-orange-default font-bold text-xl">Email</p>
              <p className="text-white font-medium">anneuhiriwe@gmail.com</p>
            </div>
            <div className="container">
              <p className="text-orange-default font-bold text-xl">Phone</p>
              <p className="text-white font-medium">+250786021869</p>
            </div>
            <div className="container">
              <div className="social_meds flex text-white focus:outline-none gap-2">
                <h2 className="text-orange-default font-bold text-xl">Social links</h2>
                <div className="flex pl-6 pt-1 gap-2">
                  <a href="-" target="_blank" rel="noopener noreferrer" className="hover:text-orange-100">
                    <IoMdCall size="24" />
                  </a>
                  <a href="https://www.instagram.com/ann__leslie" target="_blank" rel="noopener noreferrer" className="hover:text-orange-100">
                    <IoLogoInstagram size="24" />
                  </a>
                  <a href="https://www.linkedin.com/in/uhiriwe-anne-leslie-040552256" target="_blank" rel="noopener noreferrer" className="hover:text-orange-100">
                    <IoLogoLinkedin size="24" />
                  </a>
                  <a href="https://github.com/A-Leslie" target="_blank" rel="noopener noreferrer" className="hover:text-orange-100">
                    <IoLogoGithub size="24" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        </Zoom>
      </div>
      <h1 className='text-3xl font-bold text-orange-default pt-10 flex justify-center'>SKILLS</h1>
    <Zoom>
      <Skills/>
     </Zoom>
      <h1 className='text-3xl font-bold text-orange-default pt-20 pb-0 flex justify-center'>SERVICES</h1>
       <Zoom left>
   <div className='services grid md:grid-cols-3 gap-8 mt-16 w-11/12 pl-10 lg:w-10/12 lg:pl-48'>
    
      <div className='service-card p-6 bg-grey-default rounded-lg flex flex-col items-center'>
        <FaPaintbrush size='48' className='text-orange-default mb-4' />
        <h2 className='text-orange-default font-bold text-lg mb-2'>UI/UX Design</h2>
        <p className='text-white text-center'>
          Create visually stunning and user-friendly designs that enhance the
          user experience.
        </p>
      </div>
      <div className='service-card p-6 bg-grey-default rounded-lg flex flex-col items-center'>
        <FaLaptopCode size='48' className='text-orange-default mb-4' />
        <h2 className='text-orange-default font-bold text-lg mb-2'>Frontend Dev.</h2>
        <p className='text-white text-center'>
          Develop interactive and responsive frontend solutions using modern web
          technologies.
        </p>
      </div>
      <div className='service-card p-6 bg-grey-default rounded-lg flex flex-col items-center'>
        <DiDatabase size='48' className='text-orange-default mb-4' />
        <h2 className='text-orange-default font-bold text-lg mb-2'>Backend Dev.</h2>
        <p className='text-white text-center'>
          Build robust and scalable backend systems to handle data processing
          and server-side operations.
        </p>
      </div>
      <div className='service-card p-6 bg-grey-default rounded-lg flex flex-col items-center'>
        <DiResponsive size='48' className='text-orange-default mb-4' />
        <h2 className='text-orange-default font-bold text-lg mb-2'>Responsive Design</h2>
        <p className='text-white text-center'>
          Ensure your website looks and functions seamlessly across various
          devices and screen sizes.
        </p>
      </div>
      <div className='service-card p-6 bg-grey-default rounded-lg flex flex-col items-center'>
        <FaServer size='48' className='text-orange-default mb-4' />
        <h2 className='text-orange-default font-bold text-lg mb-2'>Server Management</h2>
        <p className='text-white text-center'>
          Handle server setup, deployment, and maintenance to keep your
          application running smoothly.
        </p>
      </div>
      <div className='service-card p-6 bg-grey-default rounded-lg flex flex-col items-center'>
        <FaFigma size='48' className='text-orange-default mb-4' />
        <h2 className='text-orange-default font-bold text-lg mb-2'>Figma</h2>
        <p className='text-white text-center'>
          Collaborate and design with Figma to create stunning user interfaces
          and prototypes.
        </p>
      </div>
    </div>
    </Zoom>
    <section className='lg:p-20'>
    <Slide bottom>
          <ReachMe />
        </Slide>
    </section>
     
    </div>
    </section>

  );
};

export default About;
 
